import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { clearAuthTokens } from '../utils/auth';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    clearAuthTokens();
    navigate('/login');
  };

  return (
    <Result
      status="403"
      title="403"
      subTitle="Sorry, you are not authorized to access this page."
      extra={
        <Button type="primary" onClick={handleBackToLogin}>
          Back to Login
        </Button>
      }
    />
  );
};

export default Unauthorized;